// Gọi API: dùng services/apiClient.js (API v1 — /api/v1, xem docs/api-v1/openapi.yaml).
// File này chỉ giữ base URL của backend, dùng chung cho apiClient và đường dẫn file tĩnh (/uploads...).
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000',
  TIMEOUT: process.env.REACT_APP_API_TIMEOUT || 30000
};

// Helper function để tạo URL đầy đủ
export const createApiUrl = (endpoint) => {
  // Nếu dùng proxy dev (CRA setupProxy), trả về relative path để tránh CORS/preflight
  if (process.env.REACT_APP_USE_PROXY === 'true') {
    return endpoint;
  }
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};
